import api, { chargeApi } from './api';

const BASE_URL = '/invoices/v2';

const enrollments = (socialNumber, birthday, reCaptchaToken) =>
  chargeApi.get(`${BASE_URL}/enrollments`, {
    params: { social_number: socialNumber, birthday },
    headers: { 'g-recaptcha': reCaptchaToken },
  });

const enrollmentsDetails = (socialNumber, birthday, reCaptchaToken) =>
  api.get(`/enrollments/details`, {
    params: { social_number: socialNumber, birthday },
    headers: { 'g-recaptcha': reCaptchaToken },
  });

const getInvoiceByIntegrationId = (integrationId, reCaptchaToken) =>
  chargeApi.get(`/invoices/${integrationId}`, {
    headers: { 'g-recaptcha': reCaptchaToken },
  });

const addPaymentMethod = (body, reCaptchaToken) =>
  chargeApi.post(`/invoices/payment-methods`, body, {
    headers: { 'g-recaptcha': reCaptchaToken },
  });

export default { addPaymentMethod, enrollments, enrollmentsDetails, getInvoiceByIntegrationId };
